export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email'
  ],
  'requiredFields': {
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
  }
}
